import { CollapseInterface } from '../../Interfaces/CollapseInterface'
import { PrescriptionViewModel } from '../../models/ViewModels/PrescriptionViewModel'
import { CollapseGroup } from '../../share/Components'
import Imaging from './Items/Imaging'
import Laboratory from './Items/Laboratory'
import Medication from './Items/Medication'
import Physiotherapy from './Items/Physiotherapy'
import Referral from './Items/Referral'
import Serve from './Items/Serve'

const PreviewPrescription: React.FC<PrescriptionViewModel> = ({
  id,
  image,
  laboratory,
  medication,
  physiotherapy,
  referral,
  ticketId,
  ticketServe,
  trackingCode,
  patient
}) => {
  const listCollapse: Array<CollapseInterface> = [
    {
      title: 'تجویز دارو',
      icon: 'rayteb-cog',
      className: {
        iconClass: 'text-3xl !text-primary ',
        titleClass: 'text-xs !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 rounded-md',
      },
      isShow: true,
      element: (
        <Medication
          medication={medication!}
          prescriptionId={id!}
          insuranceType={patient?.insuranceType!}
          isPreview={true}
        />
      ),
    },
    {
      title: 'تجویز آزمایش',
      icon: 'rayteb-cog',
      className: {
        iconClass: 'text-3xl !text-primary ',
        titleClass: 'text-xs !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 rounded-md',
      },
      isShow: true,
      element: (
        <Laboratory
          laboratory={laboratory!}
          prescriptionId={id!}
          isPreview={true}
        />
      ),
    },
    {
      title: 'تجویز تصویربرداری',
      icon: 'rayteb-cog',
      className: {
        iconClass: 'text-3xl !text-primary ',
        titleClass: 'text-xs !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 rounded-md',
      },
      isShow: true,
      element: (
        <Imaging imaging={image!} prescriptionId={id!} isPreview={true} />
      ),
    },
    {
      title: 'تجویز فیزیوتراپی',
      icon: 'rayteb-cog',
      className: {
        iconClass: 'text-3xl !text-primary ',
        titleClass: 'text-xs !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 rounded-md',
      },
      isShow: true,
      element: (
        <Physiotherapy
          physiotherapy={physiotherapy!}
          prescriptionId={id!}
          isPreview={true}
        />
      ),
    },
    {
      title: 'خدمات پزشکان',
      icon: 'rayteb-cog',
      className: {
        iconClass: 'text-3xl !text-primary ',
        titleClass: 'text-xs !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 rounded-md',
      },
      isShow: true,
      element: (
        <Serve
          ticketServe={ticketServe!}
          ticketId={ticketId!}
          prescriptionId={id!}
          printCode={trackingCode!}
          isPreview={true}
        />
      ),
    },
    {
      title: 'ارجاع',
      icon: 'rayteb-cog',
      className: {
        iconClass: 'text-3xl !text-primary ',
        titleClass: 'text-xs !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 rounded-md',
      },
      isShow: true,
      element: (
        <Referral referral={referral!} prescriptionId={id!} isPreview={true} />
      ),
    },
  ]
  return (
    <>
      <div className='pb-20 relative'>
        <CollapseGroup
          className='mt-2 pb-24 md:mx-auto md:w-[80%]'
          items={listCollapse}
        />
      </div>
    </>
  )
}

export default PreviewPrescription
